import { PatternCategory, PatternMap } from './models/patterns.interfaces';
import {
  addressPatterns,
  contactPatterns,
  namePatterns,
  securityPatterns,
  securityTravelerPatterns
} from './regex-patterns';

export const patternMap: Record<PatternCategory, PatternMap> = {
  name: namePatterns,
  address: addressPatterns,
  contact: contactPatterns,
  security: securityPatterns,
  securityTraveler: securityTravelerPatterns
};
